import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CustomizeLogoClient } from "../../../../../../Wrap/Api/Settings/CustomizeLogo";
import { CompanyLogo } from "../../../../../../Wrap/Models/Domains/Company/CompanyLogo";
import { FirmLogoDispatcher } from "../../../../Stroes/Variable";
import { UserStore } from "../../../../../Dashboard/Stroes/Variable";

export class AddLogoAction {
    public static uploadLogo(imageUrl: { primary: string; secondary: string }, callBack: () => void) {
        const client = new CustomizeLogoClient();
        const promise = client.post(imageUrl?.primary, imageUrl?.secondary);
        promise.onSuccess(() => {
            if (callBack) {
                callBack();
            }
        });
    }

    public static getLogo(isAdmin: boolean, callBack?: (logo: CompanyLogo) => void) {
        const client = new CustomizeLogoClient();

        const promise = client.get(isAdmin);
        promise.onSuccess((res) => {
            FirmLogoDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: res,
            });
            if (callBack) {
                callBack(res);
            }
        });
    }
}
